import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';

import type { PredefinedMessage } from '@/types/predefined-messages';

const ESTIMATED_ROW_PX = 56;

export function usePredefinedMessageQueriesVirtualizer(filteredMessages: PredefinedMessage[]) {
  const parentRef = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/incompatible-library
  const rowVirtualizer = useVirtualizer({
    count: filteredMessages?.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ESTIMATED_ROW_PX,
    overscan: Number.POSITIVE_INFINITY,
    getItemKey: (index) => filteredMessages[index]?.id ?? index,
    useFlushSync: false,
  });

  return { parentRef, rowVirtualizer };
}

export { usePredefinedMessageQueriesVirtualizer as usePredefinedMessagesVirtualizer };
